export default momentDate =>
  `${momentDate.hour()}:${`0${momentDate.minute()}`.slice(-2)}`;
